<template>
<div class="order-container">
  <Header title="评价"></Header>
    <div class="order-container">
    <!-- <RateCard></RateCard> -->
    <div class="rate">
      <p>商品质量：
        <van-rate :size="20"
          void-icon="star"
          :disabled="isView"
          v-model="form.commodityQualityStar" />
     </p>
      <p>卖家服务：
         <van-rate :size="20"
          void-icon="star"
          :disabled="isView"
          v-model="form.sellerServiceStar" />
      </p>
      <p>物流配送：
         <van-rate :size="20"
          void-icon="star"
          :disabled="isView"
          v-model="form.logisticsStar" />
      </p>     
    </div>
    <div class="file">
      <p>评论图片：</p>
      <div v-if="isView">
        <img :src="form.imageShowUrl" />
      </div>
      <div v-else>
        <PetroImgUpload ></PetroImgUpload>
      </div>
    </div>
    <div>
      <p>评价信息：</p>
      <van-field
        v-model="form.comment"
        class="message"
        rows="5"
        :disabled="isView"
        autosize
        type="textarea"
        maxlength="100"
        placeholder="请输入评价信息"
        show-word-limit
      />
      <!-- <p>快捷评价：
        <van-tag plain type="primary" 
          v-for="(item, index) in valueSet.QUICK_EVALUATION"
          :key="index"
          :checked="false"
          :name="item.itemName"
          @click="selectTag">{{ item.itemName }}</van-tag>
      </p> -->
    </div>
    <div class="btndiv" v-show="!isView">
      <van-button class="btn" @click="submit">发表评论</van-button>
    </div>
    
  </div>

</div>

</template>
<script>
import Header from '@/components/Header.vue';
import PetroImgUpload from "@/components/PetroImgUpload";
import transactionApi from "@/request/transactionApi";
// import commonApi from "@/request/commonApi";
export default {
  name: "Order",
  components: {
    Header,
    PetroImgUpload,
  },
  data() {
    return {
      fileList: [],
      message: "",
      visiable: false,
      isView: false,
      form: {
        orderId: this.$route.query.id,
        commodityQualityStar: null,
        sellerServiceStar: null,
        logisticsStar: null,
        imageShowUrl: "",
        comment: ""
      }

    };
  },
  computed: {
    // valueSet() {
    //   return this.$store.state.codeValue.valueSet;
    // }
  },
  watch: {
    
  },
  created() { 
    if (this.form.orderId) {
      this.viewComment();
    }

  },
  methods: {
    afterRead(file) {
      console.log("file", file);
    },
    viewComment() {
      transactionApi.getEvaluation({
        orderId: this.form.orderId
      }).then(res=> {
        if (res.returnCode == "0") {
          this.isView = true;
          this.form = { ...res.result };
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }

      });
      
    },
    selectTag(checked, name) {
      if (checked) {
        if (!this.form.comment || this.form.comment.indexOf(name) == -1) {
          this.form.comment += name;
        }
      } else {
        var reg = new RegExp("\\" + name);
        if (this.form.comment && this.form.comment.indexOf(name) !== -1) {
          this.form.comment = this.form.comment.replace(reg, "");
        }
      }
    },
    submit() {
      transactionApi.saveEvaluation(this.form).then(res=> {
        if (res.returnCode == "0") {
          this.$toast.success("评价成功");
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }

      });
      
    }
   
  },
};
</script>
<style lang="stylus" scoped>
.order-container >>> .van-uploader__upload {
    height: 200px;
    width: 200px;
}
 .order-container >>>  .van-uploader__preview-image {
    height: 200px;
    width: 200px;
 }
.order-container {
  margin: 30px 50px;
  font-size: 28px;
  .rate {
      p {
        line-height: 60px;
      }
  }
  .file {
    margin-top: 10px;
    p {
      display inline-block; 
    }
  }
  .message {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .btndiv {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 120px;
    margin-top: 20px;
    .btn {
      min-width: 90%;
      height: 72px;
      background: rgba(255, 0, 0, 1);
      color: #ffffff;
      font-size: 32px;
      border-radius: 20px;
    }
  }

}

</style>